import { render } from "./SelectedEmailAndAssignment.vue?vue&type=template&id=2d4175d0&scoped=true"
import script from "./SelectedEmailAndAssignment.vue?vue&type=script&lang=js"
export * from "./SelectedEmailAndAssignment.vue?vue&type=script&lang=js"

import "./SelectedEmailAndAssignment.vue?vue&type=style&index=0&id=2d4175d0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2d4175d0"]])

export default __exports__